var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineLinear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.88877 3V18.1102H19.999V19.999H3V3H4.88877ZM18.9979 5.7765L21 7.77859L15.277 13.5035L12.4439 10.6703L8.72298 14.3912L6.72088 12.3872L12.4439 6.66422L15.277 9.49738L18.9979 5.7765V5.7765Z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineLinear);
export default __webpack_public_path__ + "static/media/LineLinear.02c8fc1418ffa3676fe631759e00c630.svg";
export { ForwardRef as ReactComponent };